import { useOverlayContext } from "../../../../contexts";
import { sendErrReport } from "../../../../infra/utils";
import { useAppConfig } from "../../../../store/store-context";
import { NameThisDocumentModal } from "../../NameThisDocumentModal/NameThisDocumentModal";
import { useUploadLegalTerms } from "./hooks/useUploadLegalTerms";
import { jsx as _jsx } from "react/jsx-runtime";
export class PDFError extends Error {
  constructor(message) {
    super(message);
  }
}
export const useUploadLegalTermsWithCustomName = _ref => {
  let {
    onSettled,
    errorToastTestId
  } = _ref;
  const {
    termsAndConditionsPDFSizeLimitInMegabytes: pdfSizeLimit
  } = useAppConfig();
  const {
    showModal,
    showErrorToast
  } = useOverlayContext();
  const {
    uploadLegalTerms,
    isLoading
  } = useUploadLegalTerms({
    onSettled,
    errorToastTestId
  });
  const uploadLegalTermsWithCustomName = async file => {
    try {
      if (!file) {
        throw new PDFError('An uknown error has occurred.');
      }
      if (file.type !== 'application/pdf') {
        throw new PDFError('File is not a valid PDF.');
      }
      if (file.size > pdfSizeLimit * 1024 * 1024) {
        throw new PDFError('Selected file is too large. Please select a smaller one.');
      }
      const uploadedLegalTerms = await showModal({
        content: _ref2 => {
          let {
            dismissModal
          } = _ref2;
          return /*#__PURE__*/_jsx(NameThisDocumentModal, {
            currentFileName: file === null || file === void 0 ? void 0 : file.name,
            onConfirm: async newFileName => await uploadLegalTerms({
              file,
              newFileName
            }),
            dismissModal: dismissModal
          });
        }
      });
      return uploadedLegalTerms;
    } catch (error) {
      const isPdfError = error instanceof PDFError;
      const message = isPdfError ? error.message : 'An unknown error has occurred.';
      if (!isPdfError) {
        sendErrReport(error);
      }
      showErrorToast(message, errorToastTestId);
    }
  };
  return {
    uploadLegalTerms: uploadLegalTermsWithCustomName,
    isLoading
  };
};